
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input } from "../../../_metronic/_partials/controls";



// Validation schema
const CustomerEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required(),
  last_name: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols"),
  email: Yup.string().email("Invalid email").required(),
  password: Yup.string()
    .min(6, "Minimum 6 symbols")
    .max(50, "Maximum 50 symbols"),
  birth: Yup.mixed().nullable(false),
});

export function ClientEditForm({
  update,
  client: document,
  actionsLoading,
  handleClose: onHide,
}) {
  const [isSubmitting, setSubmitting] = useState(false)
  const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={document}
        validationSchema={CustomerEditSchema}
        onSubmit={(values) => {
          update(values)
            .then(() => setSubmitting(false))
            .end((err) => {
              setSubmitting(false)
            })
        }}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ handleSubmit, errors, handleChange }) => (
          <>
            <Modal.Body className="  cursor-default">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <Form className="form form-label-right">
                <div className="form-group row">
                  {/* First Name */}
                  <div className="col-lg-4">
                    <Field
                      name="name"
                      component={Input}
                      placeholder="First Name"
                      label="First Name"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                  {/* Last Name */}
                  <div className="col-lg-4">
                    <Field
                      name="last_name"
                      component={Input}
                      placeholder="Last Name"
                      label="Last Name"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                  {/* Login */}
                  <div className="col-lg-4">
                    <Field
                      type="date"
                      name="birth"
                      component={Input}
                      label="Date of Birth"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                </div>
                {/* Email */}
                <div className="form-group row">
                  <div className="col-lg-4">
                    <Field
                      type="text"
                      name="phone"
                      component={Input}
                      placeholder="Phone"
                      label="Phone"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-4">
                    <Field
                      type="email"
                      name="email"
                      disabled={document.uid}
                      component={Input}
                      placeholder="Email"
                      label="Email"
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                  {/* Date of birth */}
                  <div className="col-lg-4">

                    <Field
                      disabled={document.uid}
                      type="password"
                      name="password"
                      component={Input}
                      placeholder="Password"
                      label="Password"
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>

                  {/* IP Address */}
                  {/* <div className="col-lg-4">
                  <Select name="type" label="Company">
                    <option value="0">Business</option>
                    <option value="1">Individual</option>
                  </Select>
                </div> */}
                </div>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                onClick={onHide}
                className="btn btn-light btn-elevate"
              >
                Cancel
            </button>
              <> </>
              <button
                onClick={() => {
                  setSubmitting(true)
                  handleSubmit()
                  setTimeout(() => setSubmitting(false), 500)
                }}
                disabled={isSubmitting}
                className="btn btn-primary btn-elevate"
              >
                {isSubmitting ?
                  <div className="d-flex align-items-center">
                    <div className="mr-2">Loading...</div>
                    <div className="spinner spinner-white mr-10"></div>
                  </div> : "Save"}
              </button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}

export function ClientEditModal(props) {
  return (
    <>
      <Modal show={props.show} onHide={props.handleClose} size="lg">
        <Modal.Header>
          <h1>{props.client.uid ? "Edit Admins" : "New Admins"}</h1>
        </Modal.Header>

        <ClientEditForm {...props} />
      </Modal>
    </>
  );
}
export function ClienDeleteModal(props) {
  return (
    <>
      <Modal
        show={props.delete}
        onHide={props.hideDelete}
        size="lg"
        dialogClassName="p-5"
      >
        <Modal.Header>
          <h1>Delete Admins</h1>
        </Modal.Header>
        <Modal.Body>
          Are you sure to permanently delete this <b>Admins</b>?
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            onClick={props.hideDelete}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="submit"
            onClick={() => props.deleteClient(props.client.uid)}
            className="btn btn-danger btn-elevate"
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
